if (!customElements.get('product-form-condensed')) {
  class ProductFormCondensed extends HTMLElement {
    constructor() {
      super();
    }
    
    connectedCallback() {
      this.parentForm = this.closest('product-form');
      if (!this.parentForm) return;
      this.shuffle = this.closest('sparky-shuffle');
      this.actionButton = this.querySelector('[data-action-button]');
      
      this.getState();
      this.updateVariant();
            
      this.actionButton.addEventListener('click', () => {
        if (this.state.areAllSelectionsMade) {
          this.parentForm.dispatchEvent(new Event('submit'));
          return;
        }
        
        this.parentForm.scrollIntoView({ behavior: 'smooth', block: 'end' });
      });
      window.addEventListener('productForm:skuChange', () => {
        this.parentForm = this.closest('product-form');
        if (!this.parentForm) return;
        this.getState();
        this.updateVariant();
      });      
    }
    
    getState() {
      const {
        areAllSelectionsMade,
        currentVariant,
        cartesian,
        readyToAdd,
        atcButton
      } = this.parentForm;
      
      this.state = { 
        areAllSelectionsMade, 
        currentVariant,
        cartesian,
        readyToAdd,
        atcButton
      };
    }
    
    updateVariant() {
      this.actionButton.innerHTML = this.state.atcButton.cloneNode(true).innerHTML;

      if (this.state?.currentVariant?.variant_json.available) {
        this.actionButton.removeAttribute('disabled');
        this.actionButton.classList.replace('ghost', 'primary');
        return;
      }
      
      if (this.state.areAllSelectionsMade) {
        this.actionButton.setAttribute('disabled', true);
        this.actionButton.classList.replace('primary', 'ghost');
      }
    }
  }
  
  customElements.define('product-form-condensed', ProductFormCondensed);
}